import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import taskService from '../../services/taskService';
import projectService from '../../services/projectService';
import milestoneService from '../../services/milestoneService';
import { FiUpload, FiX, FiFile, FiPlus } from 'react-icons/fi';
import VendorStore from './VendorStore';
import vendorDashboardService from '../../services/vendorDashboardService';
import { toast } from 'react-toastify';
import ContractStore from './ContractStore';

const TABS = [
    { id: 'details', label: 'Contract Details' },
    // { id: 'attachments', label: 'Attachments' },
];

const UserVendorCreateContract = ({ isEdit = false }) => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [activeTab, setActiveTab] = useState('details');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [projects, setProjects] = useState([]);
    const [milestones, setMilestones] = useState([]);
    const [tasks, setTasks] = useState([]);
    const [users, setUsers] = useState([]);
    const [attachments, setAttachments] = useState([]);
    const [dragOver, setDragOver] = useState(false);
    const [pendingFile, setPendingFile] = useState(null);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [file, setFile] = useState(null);

    const [formData, setFormData] = useState({
        contract_name: '',
        contract_type: '',
        description: '',
        status: '',
        start_date: '',
        end_date: '',
        renewal_date: '',
        auto_renewal: '',
        renewal_notice_days: '',
        contract_value: '',
        currency: '',
        payment_terms: '',
        payment_schedule: '',
        terms_and_conditions: '',
        deliverables: '',
        sla_terms: '',
        penalties: '',
        notes: '',
    });

    const { selectedVendor, setSelectedVendor, clearSelectedVendor } = VendorStore();

    const { selectedContract, setSelectedContract, clearSelectedContract } = ContractStore();

    const [currentStep, setCurrentStep] = useState(1);

    const steps = [
        {
            id: 1,
            title: "Contract Information",
            description: "Basic contract details",
        },
        {
            id: 2,
            title: "Contract Values",
            description: "Payment and financial details",
        },
        {
            id: 3,
            title: "Additional Details",
            description: "Terms and other information",
        },
    ];

    const handleNext = () => {
        if (currentStep < steps.length) {
            setCurrentStep((prev) => prev + 1);
        }
    };

    // ============================
    // BACK
    // ============================
    const handleBack = () => {
        if (currentStep > 1) {
            setCurrentStep((prev) => prev - 1);
        }
    };

    // ============================
    // STEP CLICK
    // ============================
    const handleStepClick = (step) => {
        // Optional:
        // Allow going only to completed/current steps
        if (step <= currentStep) {
            setCurrentStep(step);
        }
    };


    const step1RequiredFields = [
        "contract_name",
        "contract_type",
        "status",
        "start_date",
        "end_date",
    ];

    const step2RequiredFields = [
        "contract_value",
        "currency",
        "payment_terms",
        "payment_schedule",
    ];

    const step3RequiredFields = [
        "terms_and_conditions",
        "deliverables",
        "sla_terms",
        "penalties",
    ];

    const areFieldsFilled = (fields) => {
        return fields.every((field) => {
            const value = formData?.[field];

            return (
                value !== undefined &&
                value !== null &&
                String(value).trim() !== ""
            );
        });
    };

    const isCurrentStepValid = () => {
        if (currentStep === 1) {
            return areFieldsFilled(step1RequiredFields);
        }

        if (currentStep === 2) {
            return areFieldsFilled(step2RequiredFields);
        }

        if (currentStep === 3) {
            return areFieldsFilled(step3RequiredFields);
        }

        return false;
    };



    useEffect(() => {
        // fetchProjects();
        // fetchMilestones();
        // fetchTasks();
        // loadUsers();
        console.log("selected vendors", selectedContract)

        if (isEdit && id) {
            console.log("idddd===", id)
            fetchContract();
        }

        // if (selectedIssue) {
        //   fetchIssue();
        // }

    }, [isEdit, id, selectedVendor, selectedContract]);

    const formatDate = (timestamp) => {
        const date = new Date(timestamp);
        const today = new Date();
        const yesterday = new Date(today);
        yesterday.setDate(yesterday.getDate() - 1);

        if (date.toDateString() === today.toDateString()) {
            return 'Today';
        } else if (date.toDateString() === yesterday.toDateString()) {
            return 'Yesterday';
        } else {
            return date.toLocaleDateString('en-US', {
                month: 'short',
                day: 'numeric',
                year: date.getFullYear() !== today.getFullYear() ? 'numeric' : undefined
            });
        }
    };

    const fetchContract = () => {

        try {
            setLoading(true);
            setFormData({
                contract_name: selectedContract.contract_name || '',
                contract_type: selectedContract.contract_type || '',
                description: selectedContract.description || '',
                status: selectedContract.status || '',
                start_date: selectedContract.start_date ? selectedContract.start_date.split('T')[0] : '',
                end_date: selectedContract.end_date ? selectedContract.end_date.split('T')[0] : '',
                renewal_date: selectedContract.renewal_date ? selectedContract.renewal_date.split('T')[0] : '',
                auto_renewal: selectedContract.auto_renewal || '',
                renewal_notice_days: selectedContract.renewal_notice_days || '',
                contract_value: selectedContract.contract_value || '',
                currency: selectedContract.currency || '',
                payment_terms: selectedContract.payment_terms || '',
                payment_schedule: selectedContract.payment_schedule || '',
                terms_and_conditions: selectedContract.terms_and_conditions || '',
                deliverables: selectedContract.deliverables || '',
                sla_terms: selectedContract.sla_terms || '',
                penalties: selectedContract.penalties || '',
                notes: selectedContract.notes || '',
            });
        } catch (err) {
            setError(err.response?.data?.error || 'Failed to fetch task');
        } finally {
            setLoading(false);
        }

    }

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        setFormData(prev => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value
        }));
    };

    const contract = [
        {
            "key": "Service Agreement",
            "value": "Service Agreement"
        },
        {
            "key": "Statement of Work",
            "value": "Statement of Work"
        },
        {
            "key": "Purchase Order",
            "value": "Purchase Order"
        },
        {
            "key": "NDA",
            "value": "NDA"
        },
        {
            "key": "Consulting",
            "value": "Consulting"
        },
        {
            "key": "Subscription",
            "value": "Subscription"
        },
        {
            "key": "Other",
            "value": "Other"
        }
    ]

    const status = [
        { "key": "Draft", "value": "Draft" },
        { "key": "Under Review", "value": "Under Review" },
        { "key": "Approved", "value": "Approved" },
        { "key": "Active", "value": "Active" },
        { "key": "Expired", "value": "Expired" },
        { "key": "Terminated", "value": "Terminated" },
        { "key": "Renewed", "value": "Renewed" }
    ]

    const payment = [
        { key: "One Time", value: "One time" },
        { key: "Monthly", value: "Monthly" },
        { key: "Quarterly", value: "Quarterly" },
        { key: "Annually", value: "Annually" },
        { key: "Milestone-based", value: "Milestone-based" },
        { key: "Custom", value: "Custom" }
    ];





    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        try {
            const submitData = {
                ...formData,
                id: selectedContract?.id
            };

            if (isEdit) {
                await vendorDashboardService.updateContract(selectedVendor.id, selectedContract.id, submitData);
            } else {
                await vendorDashboardService.createContract(selectedVendor.id, submitData);
            }

            toast.success('Created successful!');

            navigate(`/app/vendors/${selectedVendor.id}/contracts`);
        } catch (err) {
            toast.error(err.response?.data?.error);
        } finally {
            setLoading(false);
        }
    };

    const handleCancel = () => navigate('/app/vendors');

    const handleFileSelect = (e) => {
        const files = Array.from(e.target.files);
        if (files.length > 0) setPendingFile(files[0]);
        simulateUpload(files);
    };

    const simulateUpload = async (files) => {
        for (let i = 0; i <= 100; i += 10) {
            setUploadProgress(i);
            await new Promise(resolve => setTimeout(resolve, 100));
        }
        addFiles(files);
        setPendingFile(null);
        setUploadProgress(0);
    };

    const addFiles = (files) => {
        const newAttachments = files.map(file => ({
            id: Date.now() + Math.random(),
            name: file.name,
            size: file.size,
            type: file.type,
            file,
            uploadedAt: new Date().toLocaleString(),
        }));
        setAttachments(prev => [...prev, ...newAttachments]);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setDragOver(false);
        const files = Array.from(e.dataTransfer.files);
        if (files.length > 0) setPendingFile(files[0]);
        simulateUpload(files);
    };
    const removeAttachment = (attachId) => {
        setAttachments(prev => prev.filter(a => a.id !== attachId));
    };

    const formatBytes = (bytes) => {
        if (bytes < 1024) return bytes + ' B';
        if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
        return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
    };

    const getFileIcon = (type) => {
        if (type.startsWith('image/'));
        if (type === 'application/pdf');
        if (type.includes('word'));
        if (type.includes('excel') || type.includes('spreadsheet'));
        if (type.includes('zip') || type.includes('rar'));
        return <FiFile size={24} style={{ color: 'var(--color-text-secondary, #9ca3af)' }} />;
    };

    if (loading && isEdit) {
        return <div className="loading">Loading task...</div>;
    }

    return (
        <div className="task-form-container" style={{ maxWidth: '100%' }}>
            <div className="task-form-header">
                <h1>{isEdit ? 'Edit Contract' : 'Create New Contract'}</h1>
            </div>

            <div className="tf-tab-bar">
                {TABS.map(tab => (
                    <button
                        key={tab.id}
                        type="button"
                        className={`tf-tab ${activeTab === tab.id ? 'tf-tab--active' : ''}`}
                        onClick={() => setActiveTab(tab.id)}
                    >
                        <span className="tf-tab-icon">{tab.icon}</span>
                        {tab.label}
                    </button>
                ))}
            </div>

            {error && <div className="alert alert-danger">{error}</div>}


            {activeTab === 'details' && (
                <>
                    <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-6 mb-6">

                        <div className="flex items-start w-full">

                            {steps.map((step, index) => {

                                const isActive = currentStep === step.id;
                                const isCompleted = currentStep > step.id;

                                return (
                                    <React.Fragment key={step.id}>

                                        {/* STEP */}
                                        <div
                                            className={`
                                            flex flex-col items-center
                                            min-w-[150px]
                                            ${step.id <= currentStep
                                                    ? "cursor-pointer"
                                                    : "cursor-default"
                                                }
                                        `}
                                            onClick={() =>
                                                handleStepClick(step.id)
                                            }
                                        >

                                            {/* Circle */}
                                            <div
                                                className={`
                                                w-11 h-11
                                                rounded-full
                                                flex items-center justify-center
                                                font-semibold
                                                text-sm
                                                transition-all duration-300
                                                ${isCompleted
                                                        ? "bg-green-600 text-white"
                                                        : isActive
                                                            ? "bg-blue-600 text-white ring-4 ring-blue-100"
                                                            : "bg-gray-200 text-gray-500"
                                                    }
                                            `}
                                            >
                                                {isCompleted ? (
                                                    <svg
                                                        className="w-5 h-5"
                                                        fill="none"
                                                        stroke="currentColor"
                                                        viewBox="0 0 24 24"
                                                    >
                                                        <path
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                            strokeWidth="2"
                                                            d="M5 13l4 4L19 7"
                                                        />
                                                    </svg>
                                                ) : (
                                                    step.id
                                                )}
                                            </div>

                                            {/* Title */}
                                            <div className="mt-3 text-center">
                                                <p
                                                    className={`
                                                    text-sm font-semibold
                                                    ${isCompleted
                                                            ? "text-green-600"
                                                            : isActive
                                                                ? "text-blue-600"
                                                                : "text-gray-500"
                                                        }
                                                `}
                                                >
                                                    {step.title}
                                                </p>

                                                <p className="text-xs text-gray-400 mt-1">
                                                    {step.description}
                                                </p>
                                            </div>
                                        </div>

                                        {/* LINE */}
                                        {index < steps.length - 1 && (
                                            <div className="flex-1 mt-5 mx-3">

                                                <div
                                                    className={`
                                                    h-[2px] w-full
                                                    transition-all duration-300
                                                    ${currentStep > step.id
                                                            ? "bg-green-500"
                                                            : "bg-gray-200"
                                                        }
                                                `}
                                                />

                                            </div>
                                        )}

                                    </React.Fragment>
                                );
                            })}

                        </div>
                    </div>

                    <form
                        onSubmit={handleSubmit}
                        className="w-full flex gap-4 p-0"
                    >

                        <div className="w-[70%] bg-gray-100">




                            {currentStep === 1 && (
                                <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-6">

                                    <h3 className="text-lg font-semibold text-gray-800 mb-6">
                                        Contract Information
                                    </h3>

                                    {/* Contract Name */}
                                    <div className="mb-5">
                                        <div className="form-group">

                                            <label htmlFor="contract_name">
                                                Contract Name
                                            </label>

                                            <input
                                                type="text"
                                                id="contract_name"
                                                name="contract_name"
                                                value={formData?.contract_name || ""}
                                                onChange={handleChange}
                                                className="form-control"
                                                required
                                                placeholder="Enter contract name"
                                            />

                                        </div>
                                    </div>


                                    {/* Contract Info Grid */}
                                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-5">

                                        {/* Contract Type */}
                                        <div className="form-group">

                                            <label htmlFor="contract_type">
                                                Contract Type
                                            </label>

                                            <select
                                                id="contract_type"
                                                name="contract_type"
                                                value={formData?.contract_type || ""}
                                                onChange={handleChange}
                                                className="form-control"
                                                required
                                            >
                                                <option value="">
                                                    Select Contract Type
                                                </option>

                                                {contract?.map((c) => (
                                                    <option
                                                        key={c.key}
                                                        value={c.key}
                                                    >
                                                        {c.value}
                                                    </option>
                                                ))}
                                            </select>

                                        </div>


                                        {/* Status */}
                                        <div className="form-group">

                                            <label htmlFor="status">
                                                Status <span className="text-danger">*</span>
                                            </label>

                                            <select
                                                id="status"
                                                name="status"
                                                value={formData?.status || ""}
                                                onChange={handleChange}
                                                className="form-control"
                                                required
                                            >
                                                <option value="">
                                                    Select Status
                                                </option>

                                                {status?.map((s) => (
                                                    <option
                                                        key={s.key}
                                                        value={s.key}
                                                    >
                                                        {s.value}
                                                    </option>
                                                ))}
                                            </select>

                                        </div>


                                        {/* Renewal Notice */}
                                        <div className="form-group">

                                            <label htmlFor="renewal_notice_days">
                                                Renewal Notice Days
                                            </label>

                                            <input
                                                type="number"
                                                id="renewal_notice_days"
                                                name="renewal_notice_days"
                                                value={
                                                    formData?.renewal_notice_days ?? ""
                                                }
                                                onChange={handleChange}
                                                className="form-control"
                                                required
                                                placeholder="Enter notice days"
                                            />

                                        </div>


                                        {/* Start Date */}
                                        <div className="form-group">

                                            <label htmlFor="start_date">
                                                Start Date
                                            </label>

                                            <input
                                                type="date"
                                                id="start_date"
                                                name="start_date"
                                                value={formData?.start_date || ""}
                                                onChange={handleChange}
                                                className="form-control"
                                            />

                                        </div>


                                        {/* End Date */}
                                        <div className="form-group">

                                            <label htmlFor="end_date">
                                                End Date
                                            </label>

                                            <input
                                                type="date"
                                                id="end_date"
                                                name="end_date"
                                                value={formData?.end_date || ""}
                                                onChange={handleChange}
                                                className="form-control"
                                            />

                                        </div>


                                        {/* Renewal Date */}
                                        <div className="form-group">

                                            <label htmlFor="renewal_date">
                                                Renewal Date
                                            </label>

                                            <input
                                                type="date"
                                                id="renewal_date"
                                                name="renewal_date"
                                                value={formData?.renewal_date || ""}
                                                onChange={handleChange}
                                                className="form-control"
                                            />

                                        </div>

                                    </div>


                                    {/* Auto Renewal */}
                                    <div className="flex items-center mb-6">

                                        <label className="flex items-center gap-2 cursor-pointer">

                                            <input
                                                type="checkbox"
                                                name="auto_renewal"
                                                checked={
                                                    Boolean(formData?.auto_renewal)
                                                }
                                                onChange={handleChange}
                                                className="w-4 h-4"
                                            />

                                            <span className="text-sm text-gray-700">
                                                Auto Renewal
                                            </span>

                                        </label>

                                    </div>


                                    {/* Description */}
                                    <div className="form-group">

                                        <label htmlFor="description">
                                            Description
                                        </label>

                                        <textarea
                                            id="description"
                                            name="description"
                                            value={formData?.description || ""}
                                            onChange={handleChange}
                                            className="form-control"
                                            rows="4"
                                            placeholder="Enter contract description"
                                        />

                                    </div>

                                </div>
                            )}


                            {currentStep === 2 && (
                                <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-6">

                                    <h3 className="text-lg font-semibold text-gray-800 mb-6">
                                        Contract Values
                                    </h3>


                                    {/* Contract Value */}
                                    <div className="mb-5">

                                        <div className="form-group">

                                            <label htmlFor="contract_value">
                                                Contract Value
                                            </label>

                                            <input
                                                type="number"
                                                id="contract_value"
                                                name="contract_value"
                                                value={
                                                    formData?.contract_value ?? ""
                                                }
                                                onChange={handleChange}
                                                className="form-control"
                                                required
                                                placeholder="Enter contract value"
                                            />

                                        </div>

                                    </div>


                                    {/* Payment Details */}
                                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">

                                        {/* Currency */}
                                        <div className="form-group">

                                            <label htmlFor="currency">
                                                Currency
                                            </label>

                                            <select
                                                id="currency"
                                                name="currency"
                                                value={formData?.currency || ""}
                                                onChange={handleChange}
                                                className="form-control"
                                                required
                                            >
                                                <option value="">
                                                    Select Currency
                                                </option>

                                                <option value="USD">
                                                    USD
                                                </option>

                                                <option value="EUR">
                                                    EUR
                                                </option>

                                                <option value="GBP">
                                                    GBP
                                                </option>

                                                <option value="INR">
                                                    INR
                                                </option>

                                                <option value="CAD">
                                                    CAD
                                                </option>

                                            </select>

                                        </div>


                                        {/* Payment Terms */}
                                        <div className="form-group">

                                            <label htmlFor="payment_terms">
                                                Payment Terms
                                            </label>

                                            <select
                                                id="payment_terms"
                                                name="payment_terms"
                                                value={
                                                    formData?.payment_terms || ""
                                                }
                                                onChange={handleChange}
                                                className="form-control"
                                                required
                                            >
                                                <option value="">
                                                    Select Payment Terms
                                                </option>

                                                <option value="Net 15">
                                                    Net 15
                                                </option>

                                                <option value="Net 30">
                                                    Net 30
                                                </option>

                                                <option value="Net 45">
                                                    Net 45
                                                </option>

                                                <option value="Net 60">
                                                    Net 60
                                                </option>

                                                <option value="Due on Receipt">
                                                    Due on Receipt
                                                </option>

                                            </select>

                                        </div>


                                        {/* Payment Schedule */}
                                        <div className="form-group">

                                            <label htmlFor="payment_schedule">
                                                Payment Schedule
                                            </label>

                                            <select
                                                id="payment_schedule"
                                                name="payment_schedule"
                                                value={
                                                    formData?.payment_schedule || ""
                                                }
                                                onChange={handleChange}
                                                className="form-control"
                                                required
                                            >
                                                <option value="">
                                                    Select Payment Schedule
                                                </option>

                                                {payment?.map((p) => (
                                                    <option
                                                        key={p.key}
                                                        value={p.key}
                                                    >
                                                        {p.value}
                                                    </option>
                                                ))}
                                            </select>

                                        </div>

                                    </div>

                                </div>
                            )}



                            {currentStep === 3 && (
                                <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-6">

                                    <h3 className="text-lg font-semibold text-gray-800 mb-6">
                                        Additional Details
                                    </h3>


                                    {/* Terms and Conditions */}
                                    <div className="form-group mb-5">

                                        <label htmlFor="terms_and_conditions">
                                            Terms & Conditions
                                        </label>

                                        <textarea
                                            id="terms_and_conditions"
                                            name="terms_and_conditions"
                                            value={
                                                formData?.terms_and_conditions || ""
                                            }
                                            onChange={handleChange}
                                            className="form-control"
                                            rows="4"
                                            placeholder="Enter terms and conditions"
                                        />

                                    </div>


                                    {/* Deliverables */}
                                    <div className="form-group mb-5">

                                        <label htmlFor="deliverables">
                                            Deliverables
                                        </label>

                                        <textarea
                                            id="deliverables"
                                            name="deliverables"
                                            value={
                                                formData?.deliverables || ""
                                            }
                                            onChange={handleChange}
                                            className="form-control"
                                            rows="4"
                                            placeholder="Enter deliverables"
                                        />

                                    </div>


                                    {/* SLA Terms */}
                                    <div className="form-group mb-5">

                                        <label htmlFor="sla_terms">
                                            SLA Terms
                                        </label>

                                        <textarea
                                            id="sla_terms"
                                            name="sla_terms"
                                            value={formData?.sla_terms || ""}
                                            onChange={handleChange}
                                            className="form-control"
                                            rows="4"
                                            placeholder="Enter SLA terms"
                                        />

                                    </div>


                                    {/* Penalties */}
                                    <div className="form-group mb-5">

                                        <label htmlFor="penalties">
                                            Penalties
                                        </label>

                                        <textarea
                                            id="penalties"
                                            name="penalties"
                                            value={formData?.penalties || ""}
                                            onChange={handleChange}
                                            className="form-control"
                                            rows="4"
                                            placeholder="Enter penalties"
                                        />

                                    </div>


                                    {/* Notes */}
                                    <div className="form-group">

                                        <label htmlFor="notes">
                                            Notes
                                        </label>

                                        <textarea
                                            id="notes"
                                            name="notes"
                                            value={formData?.notes || ""}
                                            onChange={handleChange}
                                            className="form-control"
                                            rows="4"
                                            placeholder="Enter notes"
                                        />

                                    </div>

                                </div>
                            )}



                        </div>

                        <div className="w-[30%] bg-gray-100">
                            <div className="form-section review-section p-4">
                                <h3 className='p-4'>Client Details</h3>
                                <div className="m-4">
                                    <div className="review-card mb-4">
                                        <h4><i className="fas fa-building"></i>Basic Information</h4>
                                        <span className="vendor-code">
                                            {selectedVendor?.vendor_code}
                                        </span>
                                        <p><strong>Company:</strong> {selectedVendor?.company_name}</p>
                                        <p><strong>Type:</strong> {selectedVendor?.vendor_type}</p>
                                        <p><strong>Category:</strong> {selectedVendor?.category}</p>
                                    </div>
                                    <div className="review-card">
                                        <h4><i className="fas fa-address-card"></i> Contact Details</h4>
                                        <p><strong>Email:</strong> {selectedVendor?.email}</p>
                                        <p><strong>Phone:</strong> {selectedVendor?.phone}</p>
                                        <p><strong>Address:</strong> {selectedVendor?.address}</p>
                                    </div>


                                    <div className="flex items-center gap-4 mt-7">
                                        <label
                                            htmlFor="file-upload"
                                            className="inline-flex cursor-pointer items-center gap-2 text-blue-600 font-medium hover:text-blue-700 transition-colors"
                                        >
                                            <FiUpload className="text-[2rem]" />
                                            <span className="text-lg font-medium">Upload</span>
                                        </label>

                                        <span className="text-sm text-gray-600 truncate">
                                            {file ? file.name : "No file selected"}
                                        </span>

                                        <input
                                            id="file"
                                            type="file"
                                            className="hidden"
                                            onChange={(e) => setFile(e.target.files[0])}
                                        />
                                    </div>

                                </div>
                            </div>

                            <div className="flex items-center justify-between mt-6 p-4 bg-white rounded-xl border border-gray-200 shadow-sm">

                                {/* CANCEL */}
                                <button
                                    type="button"
                                    onClick={handleCancel}
                                    disabled={loading}
                                    className="
                            px-5 py-2.5
                            rounded-lg
                            border border-gray-300
                            bg-white
                            text-gray-700
                            hover:bg-gray-50
                            transition
                            disabled:opacity-50
                            disabled:cursor-not-allowed
                        "
                                >
                                    Cancel
                                </button>


                                <div className="flex items-center gap-3">

                                    {/* BACK */}
                                    {currentStep > 1 && (
                                        <button
                                            type="button"
                                            onClick={handleBack}
                                            disabled={loading}
                                            className="
                                    px-5 py-2.5
                                    rounded-lg
                                    border border-gray-300
                                    bg-white
                                    text-gray-700
                                    hover:bg-gray-50
                                    transition
                                    disabled:opacity-50
                                "
                                        >
                                            ← Back
                                        </button>
                                    )}


                                    {/* NEXT */}
                                    {currentStep < steps.length && (
                                        <button
                                            type="button"
                                            disabled={!isCurrentStepValid()}
                                            onClick={() => {
                                                if (isCurrentStepValid()) {
                                                    setCurrentStep((prev) => prev + 1);
                                                }
                                            }}
                                            className={`px-6 py-2.5 rounded-lg font-medium transition ${isCurrentStepValid()
                                                    ? "bg-blue-600 text-white hover:bg-blue-700 cursor-pointer"
                                                    : "bg-gray-300 text-gray-500 cursor-not-allowed"
                                                }`}
                                        >
                                            Next
                                        </button>
                                    )}


                                    {/* CREATE / UPDATE */}
                                    {currentStep === steps.length && (
                                        <button
                                            type="submit"
                                            disabled={loading}
                                            className="
                                    px-6 py-2.5
                                    rounded-lg
                                    bg-blue-600
                                    text-white
                                    hover:bg-blue-700
                                    transition
                                    font-medium
                                    disabled:opacity-50
                                    disabled:cursor-not-allowed
                                "
                                        >
                                            {loading
                                                ? "Saving..."
                                                : isEdit
                                                    ? "Update Contract"
                                                    : "Create Contract"
                                            }
                                        </button>
                                    )}

                                </div>
                            </div>
                        </div>

                    </form>



                </>
            )}
        </div>
    );
};

export default UserVendorCreateContract;

